import { useLayoutEffect, useState } from 'react';
import { getSitePlatform } from 'helpers/BreakpointHelper';
import useWindowSize from './useWindowSize';

function useBreakpoint() {
  // THIS IS DEFAULT BREAKPOINT USAGE
  const [breakpoint, setBreakPoint] = useState(getSitePlatform());
  const { width } = useWindowSize();

  useLayoutEffect(() => {
    const siteBreakpoints = window?.ExternalConfig?.breakpoints?.site;
    const breakpoints = {
      375: siteBreakpoints.mobile,
      768: siteBreakpoints.tablet,
      1024: siteBreakpoints.web,
      2560: siteBreakpoints.webLarge,
    };

    if (width >= 0 && width < 768) {
      setBreakPoint(breakpoints[375]);
    }
    if (width >= 768 && width < 1024) {
      setBreakPoint(breakpoints[768]);
    }
    if (width >= 1024 && width < 2560) {
      setBreakPoint(breakpoints[1024]);
    }
    if (width >= 2560) {
      setBreakPoint(breakpoints[2560]);
    }
  }, [width]);

  return breakpoint;
}

export default useBreakpoint;
